import * as R from 'ramda'
import { reduxSearch } from 'redux-search'
import { projectsEx } from './projects'
import { propertiesEx } from './properties'
import { tasksEx } from './tasks'
import createSelector from 'utils/redux/createSelector' // import { createSelector } from 'reselect'
import { transactionsEx } from './transactionsTable'
import { leasesEx } from './leases'
import { tenantsEx } from './tenant'
import { allEx } from './globalSearch'
import { createSearchAction, getSearchSelectors } from 'redux-search'

// let tasksXXX = createSelector (
// 	[projectsEx, tasksEx], (projectsEx, tasksEx) => {
// 		var r = Object.keys(tasksEx).slice(0, 1).reduce((o, id) => {o[id] = tasksEx[id]; return o}, {})
// 		// var o = projectsEx[1488865669052]
// 		// if (o) r[1488865669052] = o
// 		// debugger
// 		console.log('tasksXXX', r, tasksEx);
// 		return r
// 	}
// )
//
// let tenantsXXX = createSelector (
// 	[projectsEx, tenantsEx], (projectsEx, tenantsEx) => {
// 		var r ={}
// 		// var r = Object.keys(transactionsEx).slice(1, 2).reduce((o, id) => {o[id] = transactionsEx[id]; return o}, {})
// 		var o = projectsEx[1488865669052]
// 		if (o) r[1488865669052] = o
// 		debugger
// 		console.log('tenantsXXX', r);
// 		return r
// 	}
// )

let entities = {
	project: projectsEx
  , property: propertiesEx
  , task: tasksEx
  , transaction: transactionsEx
  , lease: leasesEx
  , tenant: tenantsEx
  , all: allEx
}

let prev = {}

export let selector = (entity, state) => {
	let start = new Date().valueOf()
	let x = entities[entity](state)
	let dt = new Date().valueOf() - start
	let eq = prev[entity] == x || !prev[entity]
	if (!eq) {
		console.warn('search.'+entity, dt + 'ms')
	}
	prev[entity] = x
	return x
}

export let storeEnhancer = reduxSearch({
	resourceIndexes: {
		project: ['propertyAlias', 'managerName', 'title']
	  , property: ['alias', 'address', 'owner', 'agent']
	  , task: ['taskContent', 'property', 'project', 'manager', 'taskType']
	  , transaction: ['party', 'property', 'description', 'amountString', 'paymentMethod', 'dueDateString']
	  , lease: ['property', 'tenant', 'rentString', 'dateFromString', 'dateTillString']
	  , tenant: ['tenant', 'phoneNumber', 'number', 'email']
	  , all: ['propertyAlias', 'managerName', 'title', 'agent', 'number','alias', 'address', 'owner', 'taskContent', 'property', 'project', 'manager', 'taskType', 'party', 'description', 'amountString', 'paymentMethod', 'dueDateString', 'tenant', 'rentString', 'dateFromString', 'dateTillString', 'phoneNumber', 'email']
	}
  , resourceSelector: selector
})

export default (state) => R.reduce(
	(commentsLine, comments) =>
		R.concat(commentsLine, R.reduce((coms, comment) => R.concat(coms, comment),[], comments))
	  , []
	  , R.map(doc =>
			R.map(comment =>
				comment = {...comment, docID: doc._id}
			  , doc.comments
			)
		  , R.filter(
				entity => entity.comments && entity.comments.length
			  , R.values(state.data)
			)
		)
)



// WEBPACK FOOTER //
// ./src/selectors/search.js